import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-grid-messages',
  templateUrl: './grid-messages.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridMessagesComponent {
}
